import { DEBUG } from '@src/DEBUG'; 
DEBUG.open ( '/init/init.component.ts' );

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatStepper, MatSnackBar, MatDialog } from '@angular/material';
import { Validators, FormControl } from '@angular/forms';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { flatMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { BaseComponent } from '../commons/BaseComponent';
import { AppService } from '../commons/app.service';
import { XsApplicationEventsService } from '../xs/services/events/application-events.service';

@Component({
  selector: 'admin-init',
  templateUrl: './init.component.html',
  styleUrls: ['./init.component.scss']
})
export class InitComponent extends BaseComponent implements OnInit {

  curComponent:any

  status
  changeServer

  constructor(public service:AppService, private route: ActivatedRoute, public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog, applicationEvents:XsApplicationEventsService) {
    super(router, snackBar, dialog);
    DEBUG.log ( '/init/init.component.ts' );
  }

  ngOnInit() {
    DEBUG.log ( '/init/init.component.ts', 'onInit()' );
  }

  componentAdded(comp) {
    this.curComponent = comp
    DEBUG.log ( '/init/init.component.ts', 'componentAdded()', comp );
  }
}
